<template>
	<div
		:class="[
			'weekly-weather',
			{ 'is-loading': isLoading }
		]"
		id="js_weeklyweather"
	>
		<!-- ローディング -->
		<transition name="fade">
			<div v-if="isLoading" class="weekly-weather__loading">
				<webview-redraw-progress />
			</div>
		</transition>
		<!-- /ローディング -->

		<!-- エラー -->
		<div v-if="isError" class="weekly-weather__error">
			<common-error-message>データを正常に<br>取得できませんでした</common-error-message>
		</div>
		<!-- /エラー -->

		<!-- 週間天気-->
		<div v-else class="weekly-weather__inner">
			<ul class="weekly-weather__list">
				<li
					v-for="(item, index) in computedWeeklyWeatherData"
					:key="`weekly-weather-${index}`"
					class="weekly-weather__item"
				>
					<p class="weekly-weather__item--date"><span class="is-day">{{ item.date }}</span><span :class="item.week_day_type">({{ item.week_day }})</span></p>
					<p class="weekly-weather__item--weather"><i :class="`sprite tenki_${item.tenki_id}`" /></p>
					<p class="weekly-weather__item--pressure"><i :class="`sprite pressure_icon_lv${item.pressure_level}`" /></p>
					<p class="weekly-weather__item--temp-max">{{ item.hight_temp }}<span class="is-small">&#8451;</span></p>
					<p class="weekly-weather__item--temp-min">{{ item.low_temp }}<span class="is-small">&#8451;</span></p>
					<p class="weekly-weather__item--percent">{{ item.percent }}<span class="is-small">%</span></p>
					<p :class="[
						'weekly-weather__item--reliability',
						{ 'is-visiable': index > 6 }
					]"><i :class="`sprite reliability_${item.reliability}`" /></p>
				</li>
			</ul>
			<a href="javascript:void(0);" @click.prevent="isVisibleModal = true" class="weekly-weather__discription">
				<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
					<g fill="none" stroke="#666" stroke-width="1">
						<circle cx="6" cy="6" r="6" stroke="none"/>
						<circle cx="6" cy="6" r="5.5" fill="none"/>
					</g>
					<text transform="translate(2)" fill="#666" font-size="8" font-family="mplus-1c-medium, 'M\+ \31 c'" font-weight="500" letter-spacing="0.04em"><tspan x="2.704" y="9">i</tspan></text>
				</svg>
				<span>天気信頼度：A～C</span>
			</a>
		</div>

		<!-- 信頼度ポップアップ -->
		<transition name="fade">
			<!-- NOTE: 天気予報Webview表示時の描画パフォーマンスを考慮してv-ons-modalを使わずv-ifで実装した（v-ons-modalはページ読み込み時にdisplay:nodeでDOMが構築される）。 -->
			<aside v-if="isVisibleModal" class="weekly-weather__modal">
				<div class="weekly-weather__modal--inner">
					<h2 class="weekly-weather__modal--title">
						<a href="javascript:void(0);" @click.prevent="isVisibleModal = false" class="weekly-weather__modal--button">
							<svg xmlns="http://www.w3.org/2000/svg" width="15.414" height="15.414" viewBox="0 0 15.414 15.414">
								<g transform="translate(0.707 0.707)">
									<g transform="translate(0 0)">
										<line x1="14" y2="14" transform="translate(0)" fill="none" stroke="#1ebfbb" stroke-linecap="round" stroke-width="1"/>
										<line x2="14" y2="14" transform="translate(0)" fill="none" stroke="#1ebfbb" stroke-linecap="round" stroke-width="1"/>
									</g>
								</g>
							</svg>
						</a>
						<span>天気信頼度</span>
					</h2>
					<p class="weekly-weather__modal--text">その日の天気予報（雨が降る/降らない）<br>に対する信頼度の高さを表します。</p>
					<ul class="weekly-weather__modal--list">
						<li class="weekly-weather__modal--item">
							<svg xmlns="http://www.w3.org/2000/svg" width="47.5" height="34" viewBox="0 0 47.5 34">
								<path d="M3.5,0,7,6H0Z" transform="translate(47.5 13.5) rotate(90)" fill="#4c4c4c"/>
								<g transform="translate(-14.965 -23.929)">
									<circle cx="17" cy="17" r="17" transform="translate(14.965 23.929)" fill="#e6e6e6"/>
									<text  transform="translate(17.965 27.929)" fill="#666" font-size="18" font-family="mplus-1c-medium, 'M\+ \31 c'" font-weight="500" letter-spacing="0.04em"><tspan x="7.934" y="19">A</tspan></text>
								</g>
							</svg>
							<span>信頼度が高く、<br>予報が変わる可能性は低い。</span>
						</li>
						<li class="weekly-weather__modal--item">
							<svg xmlns="http://www.w3.org/2000/svg" width="47.5" height="34" viewBox="0 0 47.5 34">
								<path d="M3.5,0,7,6H0Z" transform="translate(47.5 13.5) rotate(90)" fill="#4c4c4c"/>
								<g transform="translate(-14.965 -20.929)">
									<circle cx="17" cy="17" r="17" transform="translate(14.965 20.929)" fill="#e6e6e6"/>
									<text transform="translate(17.965 24.929)" fill="#666" font-size="18" font-family="mplus-1c-medium, 'M\+ \31 c'" font-weight="500" letter-spacing="0.04em"><tspan x="8.519" y="19">B</tspan></text>
								</g>
							</svg>
							<span>信頼度がやや高く、予報が<br>変わる可能性は比較的低い。</span>
						</li>
						<li class="weekly-weather__modal--item">
							<svg xmlns="http://www.w3.org/2000/svg" width="47.5" height="34" viewBox="0 0 47.5 34">
								<path d="M3.5,0,7,6H0Z" transform="translate(47.5 14.5) rotate(90)" fill="#4c4c4c"/>
								<g transform="translate(-14.965 -20.929)">
									<circle cx="17" cy="17" r="17" transform="translate(14.965 20.929)" fill="#e6e6e6"/>
									<text transform="translate(17.965 24.929)" fill="#666" font-size="18" font-family="mplus-1c-medium, 'M\+ \31 c'" font-weight="500" letter-spacing="0.04em"><tspan x="8.384" y="19">C</tspan></text>
								</g>
							</svg>
							<span>信頼度がやや低く、<br>予報が変わる可能性がある。</span>
						</li>
					</ul>
					<p class="weekly-weather__modal--supplement">※2週間天気(8日目以降の天気・気温・気圧)に関しては、大まかな傾向を表したもので、気象条件によっては時間的・量的なずれが生じる場合がございますのでご留意下さい。</p>
				</div>
			</aside>
		</transition>
	</div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from 'vuex'
import { SET_WEEKLY_WEATHER } from '@/store/modules/weatherForecast/mutation-types'

// Compornents
import WebviewRedrawProgress from '@/components/Molecules/WebviewRedrawProgress'
import CommonErrorMessage from '@/components/Molecules/CommonErrorMessage'

// ライブラリ
import moment from 'moment'
moment.locale('ja')

export default {
	name: 'WeeklyWeather',
	components: {
		WebviewRedrawProgress,
		CommonErrorMessage
	},
	data () {
		return {
			isLoading: false,
			isError: false,
			isVisibleModal: false
		}
	},
	props: {
		cityCode: {
			type: String,
			default: ''
		}
	},
	created () {
	},
	mounted () {
		// データの取得
		this.getWeatherData()
	},
	computed: {
		// map Vuex getters
		...mapGetters('common', ['userId', 'userToken']),
		...mapGetters('weatherForecast', ['weeklyWeatherData']),

		// 日単位天気のデータを扱いやすいよう生成
		computedWeeklyWeatherData () {
			return this.weeklyWeatherData ? this.weeklyWeatherData.records.map(item => {
				// 気圧レベルのコンバート
				const pressureLevel = item.zutu_level_day === '0' ? 1 : item.zutu_level_day

				// 日付をMomentオブジェクトにする
				const date = moment(item.date)

				// NOTE: アイコンが同じなので「〇一時〇」の天気コードを「〇時々〇」に書き換える
				// TODO: 8日目以降の集約天気で「112」などの見たことのないコードが出てきてしまっている。週明けまさるさんに確認し必要であればコードをコンバートする。
				let tenkiId = item.day_tenki_comment
				switch (tenkiId) {
					case '102':	// 晴れ 一時 雨
						tenkiId = '103'
						break
					case '104':	// 晴れ 一時 雪
						tenkiId = '105'
						break
					case '202':	// くもり 一時 雨
						tenkiId = '203'
						break
					case '204':	// くもり 一時 雪
						tenkiId = '205'
						break
					case '309':	// 雨 一時 雪
						tenkiId = '303'
						break
					case '409':	// 雪 一時 雨
						tenkiId = '403'
						break
				}

				return {
					'date': date.format('D'),
					'week_day': date.format('ddd'),
					'week_day_type': date.format('d') === '0' ? 'is-sunday' : date.format('d') === '6' ? 'is-saturday' : '',
					'tenki_id': tenkiId,
					'hight_temp': item.hight_temp,
					'low_temp': item.low_temp,
					'percent': item.day_pre,
					'pressure_level': pressureLevel,
					'reliability': item.day_rel
				}
			}) : []
		}
	},
	methods: {
		// map Vuex actions
		...mapActions('weatherForecast', [SET_WEEKLY_WEATHER]),

		// 必要なデータをAPIリクエストする処理
		getWeatherData () {
			const today = moment()
			const endday = moment().add(9, 'days')
			const from = today.set({ 'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0 }).unix()
			const to = endday.set({ 'hour': 23, 'minute': 59, 'second': 59, 'millisecond': 999 }).unix()
			// console.log(today.format('YYYYMMDD HH:mm:SS'))
			// console.log(endday.format('YYYYMMDD HH:mm:SS'))
			// console.log(from)
			// console.log(to)

			this.isLoading = true

			// 日単位の気象データ取得API
			this.SET_WEEKLY_WEATHER({
				user_id: this.userId,
				user_token: this.userToken,
				from: from,
				to: to,
				city_code: this.cityCode
			}).then(res => {
				// console.log('SET_WEEKLY_WEATHER res: ', res)

				// API通信でOKでもエラーになるケース
				if (this.weeklyWeatherData.records && this.weeklyWeatherData.records.length !== 10) {
					console.log('Error: There is no daily data for 10 days.')
					this.isError = true	// データが10日分ないケース
				}
			}).catch(error => {
				// NOTE: エラー処理
				console.log('Error: ', error)
				this.isError = true
			}).finally(() => {
				this.isLoading = false
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variable";

$line-weekly-weather: #E6E6E6;
$color-temp-max: #FF9F5C;
$color-temp-min: #59C2FF;
$color-percent: #0071DB;
$color-saturday: #1941F5;
$color-sunday: #EB5C29;
$spacing-12: 0.75rem;

.weekly-weather {
	$parent: &;

	font-family: $lp-family-primary;
	position: relative;
	background-color: $background-primary;
	min-height: 400px;
	box-sizing: border-box;
	color: $text-primary;

	// 週間天気
	&__inner {
		max-width: 640px;
		padding: $spacing-10 0 $spacing-8;
		margin: 0 auto;
	}

	&__list {
		padding: 0 0 $spacing-8;
		margin: 0;
		list-style: none;
	}

	&__item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		min-height: 36.5px;
		padding: $spacing-2 $spacing-6;
		box-sizing: border-box;
		border-bottom: 1px solid $line-weekly-weather;
		font-size: $font-size-12;

		& > p { margin: 0; }

		&--date {
			width: 21.4286%;
			padding: 0 $spacing-14 0 $spacing-12;
			box-sizing: border-box;
			font-family: $family-primary;
			text-align: right;

			& > .is-saturday { color: $color-saturday; }
			& > .is-sunday { color: $color-sunday; }
		}

		&--weather,
		&--pressure {
			width: 13.6364%;

			& > i { margin: 0 auto; }
		}

		&--temp-max,
		&--temp-min,
		&--percent {
			width: 11.039%;
			text-align: right;

			& > .is-small { font-size: $font-size-10; }
		}

		&--temp-max { color: $color-temp-max; }

		&--temp-min { color: $color-temp-min; }

		&--percent { color: $color-percent; }

		&--reliability {
			width: 5.195%;
			opacity: 0;

			&.is-visiable { opacity: 1; }
		}
	}

	&__discription {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding: 0 $spacing-10;
		margin-left: auto;
		color: $text-primary;
		font-size: $font-size-10;
		text-decoration: none;
		box-sizing: border-box;

		& > span {
			display: inline-block;
			margin-left: $spacing-2;
		}
	}

	// 信頼度ポップアップ
	&__modal {
		position: fixed;
		width: 100vw;
		height: 100vh;
		top: 0;
		left: 0;
		background: rgba($_black, .5);
		overflow: hidden;
		z-index: 9999;

		&--inner {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 84.375%;
			max-width: 350px;
			padding: $spacing-20;
			box-sizing: border-box;
			background-color: $background-primary;
			border-radius: 10px;
		}

		&--title {
			position: relative;
			font-family: $lp-family-tertiary;
			margin: 0;
			font-size: $font-size-16;
			text-align: center;
			line-height: $line-height-1;
		}

		&--button {
			display: block;
			position: absolute;
			top: -50%;
			left: -7px;
		}

		&--text {
			margin: $spacing-4 0 0;
			font-size: $font-size-12;
			text-align: center;
		}

		&--list {
			padding: 0;
			margin: $spacing-14 0 0;
			list-style: none;
			border-bottom: 1px solid $primary;
		}

		&--item {
			display: flex;
			align-items: center;
			padding: $spacing-10 0;
			box-sizing: border-box;
			border-top: 1px solid $primary;

			& > svg,
			& > span { display: block; }

			& > span {
				font-family: $family-primary;
				margin-left: $spacing-8;
				font-size: $font-size-12;
				color: $primary;
			}
		}

		&--supplement {
			margin: $spacing-12 0 0;
			font-size: $font-size-10;
		}
	}

	// ローディング
	&.is-loading {
		padding-top: 125%;

		#{$parent}__inner { display: none; }
	}

	&__loading {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		overflow: hidden;

		/deep/ .webview-redraw-progress {
			background: url(~@/assets/img/weekly_weather_bg.svg) left bottom / 100% auto no-repeat;

			&::before {
				content: '';
				display: block;
				width: 100%;
				height: 100%;
				position: absolute;
				left: 0;
				top: 0;
				background: rgba($_black, .4);
			}
		}
	}

	// エラー
	&__error {
		position: relative;
		padding-top: 125%;
		overflow: hidden;
		background: url(~@/assets/img/weekly_weather_bg.svg) left bottom / 100% auto no-repeat;
	}

	// メディアクエリ
	@media (min-width: (375px)) {	// iPhoneX
		#{$parent}__item {
			padding: $spacing-4 $spacing-6;
			font-size: $font-size-14;
		}

		#{$parent}--temp-max,
		#{$parent}--temp-min,
		#{$parent}--percent {
			& > .is-small { font-size: $font-size-12; }
		}

		#{$parent}__discription {
			font-size: $font-size-12;

			& > svg {
				width: 14px;
				height: 14px;
			}
		}

		#{$parent}__modal {
			&--title { font-size: $font-size-18; }

			&--text { font-size: $font-size-14; }

			&--item  > span { font-size: $font-size-14; }

			&--supplement { font-size: $font-size-12; }
		}

		.sprite { transform: scale(1.1); }
	}

	@media (min-width: (414px)) {	// iPhoneXR
		#{$parent}__item {
			padding: $spacing-6 $spacing-6;
			font-size: $font-size-16;
		}

		#{$parent}--temp-max,
		#{$parent}--temp-min,
		#{$parent}--percent {
			& > .is-small { font-size: $font-size-14; }
		}

		#{$parent}__discription {
			font-size: $font-size-14;

			& > svg {
				width: 16px;
				height: 16px;
			}
		}

		#{$parent}__modal {
			&--title { font-size: $font-size-20; }

			&--text { font-size: $font-size-16; }

			&--item  > span { font-size: $font-size-16; }

			&--supplement { font-size: $font-size-14; }
		}

		.sprite { transform: scale(1.2); }
	}
}

// アニメーション
.fade-enter-active, .fade-leave-active {
	transition: opacity .2s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}

// スプライト画像
.sprite {
	background-image: url(~@/assets/img/sprite_weekly_weather.png);
	background-size: (70px / 2) (2606px / 2);
	background-repeat: no-repeat;
	display: block;

	&.pressure_icon_lv1 {
		width: (48px / 2);
		height: (48px / 2);
		background-position: (-5px / 2) (-5px / 2);
	}

	&.pressure_icon_lv2 {
		width: (48px / 2);
		height: (48px / 2);
		background-position: (-5px / 2) (-63px / 2);
	}

	&.pressure_icon_lv3 {
		width: (48px / 2);
		height: (48px / 2);
		background-position: (-5px / 2) (-121px / 2);
	}

	&.pressure_icon_lv4 {
		width: (48px / 2);
		height: (48px / 2);
		background-position: (-5px / 2) (-179px / 2);
	}

	&.pressure_icon_lv5 {
		width: (48px / 2);
		height: (48px / 2);
		background-position: (-5px / 2) (-237px / 2);
	}

	&.reliability_A {
		width: (32px / 2);
		height: (32px / 2);
		background-position: (-5px / 2) (-295px / 2);
	}

	&.reliability_B {
		width: (32px / 2);
		height: (32px / 2);
		background-position: (-5px / 2) (-337px / 2);
	}

	&.reliability_C {
		width: (32px / 2);
		height: (32px / 2);
		background-position: (-5px / 2) (-379px / 2);
	}

	&.tenki_100 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-421px / 2);
	}

	&.tenki_101 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-494px / 2);
	}

	&.tenki_103 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-567px / 2);
	}

	&.tenki_105 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-640px / 2);
	}

	&.tenki_111 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-713px / 2);
	}

	&.tenki_114 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-786px / 2);
	}

	&.tenki_117 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-859px / 2);
	}

	&.tenki_200 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-932px / 2);
	}

	&.tenki_201 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-1005px / 2);
	}

	&.tenki_202 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-1078px / 2);
	}

	&.tenki_203 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-1151px / 2);
	}

	&.tenki_204 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-1224px / 2);
	}

	&.tenki_205 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-1297px / 2);
	}

	&.tenki_211 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-1370px / 2);
	}

	&.tenki_214 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-1443px / 2);
	}

	&.tenki_217 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-1516px / 2);
	}

	&.tenki_300 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-1589px / 2);
	}

	&.tenki_301 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-1662px / 2);
	}

	&.tenki_302 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-1735px / 2);
	}

	&.tenki_303 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-1808px / 2);
	}

	&.tenki_311 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-1881px / 2);
	}

	&.tenki_313 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-1954px / 2);
	}

	&.tenki_315 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-2027px / 2);
	}

	&.tenki_400 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-2100px / 2);
	}

	&.tenki_401 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-2173px / 2);
	}

	&.tenki_402 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-2246px / 2);
	}

	&.tenki_403 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-2319px / 2);
	}

	&.tenki_411 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-2392px / 2);
	}

	&.tenki_413 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-2465px / 2);
	}

	&.tenki_414 {
		width: (60px / 2);
		height: (63px / 2);
		background-position: (-5px / 2) (-2538px / 2);
	}
}
</style>
